import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import { useEffect } from "react";

const ListRemovalSuccess = ({ cmsLabels }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        height: "50vh",
      }}
    >
      <div className="dds__message-bar__content--center dds__message-bar--success dds__d-flex dds__justify-content-between dds__flex-wrap dds__flex-sm-nowrap dds__mt-4 dds__p-3">
        <div className="dds__d-flex dds__align-items-center">
          <i className="dds__icon dds__icon--alert-check-cir dds__mr-3 dds__text--success"></i>
          <span className="dds__font-weight-bold">
            {cmsParser(cms.successfully_unsubscribed, cmsLabels)}
          </span>
        </div>
        <div
          className="dds__mt-2 dds__mt-sm-0"
          dangerouslySetInnerHTML={{
            __html: cmsParser(cms.opted_out_marketing_communication, cmsLabels),
          }}
        ></div>
      </div>
    </div>
  );
};
export default ListRemovalSuccess;
